// extracted by mini-css-extract-plugin
export default {"content_container":"AreYouSurePopup_content_container__ZKW+j"};